var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex justify-space-between" }, [
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c(
              "v-btn",
              {
                attrs: { icon: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("back")
                  }
                }
              },
              [_c("v-icon", [_vm._v("mdi-chevron-left")])],
              1
            ),
            _c("h2", { staticClass: "page-title-bar" }, [
              _vm._v(_vm._s(_vm.$t("Shelf Monitoring Detail")))
            ])
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "btn mr-2",
                attrs: { text: "" },
                on: {
                  click: function($event) {
                    _vm.captureScheduleDialog = true
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Capture Schedule")))]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn",
                attrs: { text: "" },
                on: { click: _vm.captureNow }
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-camera")]),
                _vm._v(_vm._s(_vm.$t("Capture Now")) + " ")
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "mt-4 detail-info-row" }, [
        _c("div", { staticClass: "info-col" }, [
          _c("div", { staticClass: "info-label" }, [
            _vm._v(_vm._s(_vm.$t("Location")))
          ]),
          _c("div", { staticClass: "info-value" }, [
            _vm._v(_vm._s(_vm.location))
          ])
        ]),
        _c("div", { staticClass: "info-divider" }),
        _c("div", { staticClass: "info-col" }, [
          _c("div", { staticClass: "info-label" }, [
            _vm._v(_vm._s(_vm.$t("Linked Shelf")))
          ]),
          _c("div", { staticClass: "info-value" }, [
            _vm._v(_vm._s(_vm.linkedShelves))
          ])
        ]),
        _c("div", { staticClass: "info-divider" }),
        _c("div", { staticClass: "info-col" }, [
          _c("div", { staticClass: "info-label" }, [
            _vm._v(_vm._s(_vm.$t("Linked Camera")))
          ]),
          _c("div", { staticClass: "info-value" }, [
            _vm._v(_vm._s(_vm.linkedCameras))
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "detail-tabs-row" },
        _vm._l(_vm.tabs, function(tab) {
          return _c(
            "button",
            {
              key: tab,
              staticClass: "detail-tab-btn",
              class: { active: _vm.selectedTab === tab },
              on: {
                click: function($event) {
                  return _vm.handleTab(tab)
                }
              }
            },
            [_vm._v(" " + _vm._s(tab) + " ")]
          )
        }),
        0
      ),
      _vm.selectedTab === "All"
        ? [
            _c("div", { staticClass: "detail-main" }, [
              _c("div", { staticClass: "detail-capture-list" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("#")]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("Capture Time")))])
                    ])
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.captureList, function(capture) {
                      return _c(
                        "tr",
                        {
                          key: capture.id,
                          staticClass: "capture-row",
                          class: {
                            "capture-row--selected":
                              _vm.selectedCapture === capture.id
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSelectCapture(capture)
                            }
                          }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(capture.id))]),
                          _c("td", [_vm._v(_vm._s(capture.captureTime))])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "detail-shelf-images" }, [
                _c("div", { staticClass: "detail-shelf-images-title" }, [
                  _vm._v(_vm._s(_vm.$t("Shelf Status")))
                ]),
                _c("div", { staticClass: "detail-images-area" }, [
                  _c("div", { staticClass: "block-image" }, [
                    _c("div", {
                      ref: "allShelfContainer",
                      staticClass: "vrog-container"
                    })
                  ])
                ])
              ])
            ])
          ]
        : [
            _c("div", { staticClass: "detail-main-multi-block" }, [
              _c("div", { staticClass: "detail-capture-list-block" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("#")]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("Capture Time")))])
                    ])
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.shelfcaptureList, function(capture) {
                      return _c(
                        "tr",
                        {
                          key: capture.id,
                          staticClass: "capture-row",
                          class: {
                            "capture-row--selected":
                              _vm.selectedCaptureIndex === capture.id
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSelectShelfCapture(capture)
                            }
                          }
                        },
                        [
                          _c("td", [_vm._v(_vm._s(capture.id))]),
                          _c("td", [_vm._v(_vm._s(capture.created))])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "detail-table-block" }, [
                _c("table", { staticClass: "detail-error-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v(_vm._s(_vm.$t("Shelf Error")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("Product Name")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("Action")))])
                    ])
                  ]),
                  _c(
                    "tbody",
                    [
                      !_vm.errorProducts.length
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { colspan: "3" }
                              },
                              [_vm._v(_vm._s(_vm.$t("No issues found")))]
                            )
                          ])
                        : _vm._l(_vm.errorProducts, function(item, index) {
                            return _c(
                              "tr",
                              {
                                key: index,
                                staticClass: "error-table-row",
                                class: {
                                  "error-row--selected":
                                    _vm.selectedErrorIndex === index
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleErrorRowClick(item, index)
                                  }
                                }
                              },
                              [
                                _c("td", { staticClass: "error-cell" }, [
                                  _vm._v(_vm._s(item.status || "-"))
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(item.articleName || "-"))
                                ]),
                                _c("td", [_vm._v("Auto")])
                              ]
                            )
                          })
                    ],
                    2
                  )
                ])
              ]),
              _c("div", { staticClass: "detail-images-block" }, [
                _c(
                  "div",
                  { staticClass: "detail-block-title" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("ROG")))]),
                    _c(
                      "v-icon",
                      { attrs: { small: "" }, on: { click: _vm.expandRog } },
                      [_vm._v("mdi-fullscreen")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "detail-block-content" },
                  [
                    _vm.imageLoading
                      ? [
                          _c("div", { staticClass: "no-image" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Loading image")) + "...")
                            ])
                          ])
                        ]
                      : _vm.selectedIndividualShelf &&
                        _vm.selectedIndividualShelf.rogImage
                      ? [
                          _c("div", { staticClass: "block-image" }, [
                            _c("div", {
                              ref: "rogContainer",
                              staticClass: "vrog-container"
                            })
                          ])
                        ]
                      : _c("div", { staticClass: "no-image" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("No Image Available")) + " "
                          )
                        ])
                  ],
                  2
                )
              ]),
              _c("div", { staticClass: "detail-images-block" }, [
                _c(
                  "div",
                  { staticClass: "detail-block-title" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$t("Shelf Status")))]),
                    _c(
                      "v-icon",
                      {
                        attrs: { small: "" },
                        on: { click: _vm.expandShelfStatus }
                      },
                      [_vm._v("mdi-fullscreen")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "detail-block-content" },
                  [
                    _vm.imageLoading
                      ? [
                          _c("div", { staticClass: "no-image" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("Loading image")) + "...")
                            ])
                          ])
                        ]
                      : _vm.selectedIndividualShelf &&
                        _vm.selectedIndividualShelf.shelfImage
                      ? [
                          _c("div", { staticClass: "block-image" }, [
                            _c("div", {
                              ref: "shelfContainer",
                              staticClass: "vrog-container"
                            })
                          ])
                        ]
                      : _c("div", { staticClass: "no-image" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("No Image Available")) + " "
                          )
                        ])
                  ],
                  2
                )
              ])
            ])
          ],
      _vm.showRog || _vm.showShelfStatus
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                "retain-focus": false,
                "max-width": "700",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.displaymodel,
                callback: function($$v) {
                  _vm.displaymodel = $$v
                },
                expression: "displaymodel"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "d-flex flex-column zoom-dialog-card" },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "64px",
                        "background-color": "#001E38",
                        width: "100%",
                        display: "flex",
                        "align-items": "center",
                        padding: "0 16px"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                            small: "",
                            disabled: _vm.shelfStatusZoom <= 0.25,
                            title: _vm.$t("Zoom Out")
                          },
                          on: { click: _vm.zoomOut }
                        },
                        [_c("v-icon", [_vm._v("mdi-magnify-minus-outline")])],
                        1
                      ),
                      _c("span", { staticClass: "zoom-label" }, [
                        _vm._v(
                          _vm._s(Math.round(_vm.shelfStatusZoom * 100)) + "%"
                        )
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                            small: "",
                            disabled: _vm.shelfStatusZoom >= 5,
                            title: _vm.$t("Zoom In")
                          },
                          on: { click: _vm.zoomIn }
                        },
                        [_c("v-icon", [_vm._v("mdi-magnify-plus-outline")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                            small: "",
                            title: _vm.$t("Reset Zoom")
                          },
                          on: { click: _vm.resetZoom }
                        },
                        [_c("v-icon", [_vm._v("mdi-magnify-close")])],
                        1
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: { click: _vm.handleClose }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      ref: "imageViewport",
                      staticClass: "image-viewport",
                      style: { cursor: _vm.isDragging ? "grabbing" : "grab" },
                      on: {
                        wheel: function($event) {
                          $event.preventDefault()
                          return _vm.onWheel($event)
                        },
                        mousedown: function($event) {
                          $event.preventDefault()
                          return _vm.onMouseDown($event)
                        },
                        mousemove: _vm.onMouseMove,
                        mouseup: _vm.onMouseUp,
                        mouseleave: _vm.onMouseUp
                      }
                    },
                    [
                      _vm.showRog
                        ? _c("div", { staticClass: "image-container" }, [
                            _c("div", {
                              ref: "rogModalContainer",
                              staticClass: "vrog-container",
                              style: {
                                transform:
                                  "translate(" +
                                  _vm.translateX +
                                  "px, " +
                                  _vm.translateY +
                                  "px) scale(" +
                                  _vm.shelfStatusZoom +
                                  ")",
                                transformOrigin: "0 0"
                              },
                              on: {
                                load: _vm.onImageLoad,
                                dragstart: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            })
                          ])
                        : _vm.showShelfStatus
                        ? _c("div", { staticClass: "image-container" }, [
                            _c("div", {
                              ref: "shelfModalContainer",
                              staticClass: "vrog-container",
                              style: {
                                transform:
                                  "translate(" +
                                  _vm.translateX +
                                  "px, " +
                                  _vm.translateY +
                                  "px) scale(" +
                                  _vm.shelfStatusZoom +
                                  ")",
                                transformOrigin: "0 0"
                              },
                              on: {
                                load: _vm.onImageLoad,
                                dragstart: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            })
                          ])
                        : _c("div", { staticClass: "no-image-placeholder" }, [
                            _vm._v(_vm._s(_vm.$t("No Image Available")))
                          ])
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          staticClass: "schedule-dialog",
          attrs: { persistent: "", "max-width": "760" },
          model: {
            value: _vm.captureScheduleDialog,
            callback: function($$v) {
              _vm.captureScheduleDialog = $$v
            },
            expression: "captureScheduleDialog"
          }
        },
        [
          _c("v-card", { staticClass: "popup add_store_popup" }, [
            _c(
              "h3",
              { staticClass: "page-title-bar mb-8" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-3 mt-1",
                    attrs: { size: "28", color: "#001e38" }
                  },
                  [_vm._v("mdi-clock-outline")]
                ),
                _vm._v(_vm._s(_vm.$t("Capture Schedule")))
              ],
              1
            ),
            _c("div", { staticClass: "capture-table-card mb-5" }, [
              _c("table", { staticClass: "capture-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "index-col" }, [_vm._v("#")]),
                    _c("th", [_vm._v(_vm._s(_vm.$t("ROG Capture Time")))])
                  ])
                ]),
                _c(
                  "tbody",
                  [
                    !_vm.rogCaptureTimes.length
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "2" }
                            },
                            [_vm._v(_vm._s(_vm.$t("No data available")))]
                          )
                        ])
                      : _vm._e(),
                    _vm._l(_vm.rogCaptureTimes, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(index + 1))]),
                        _c("td", [_vm._v(_vm._s(item))])
                      ])
                    })
                  ],
                  2
                )
              ])
            ]),
            _c("div", { staticClass: "capture-table-card" }, [
              _c("table", { staticClass: "capture-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "index-col" }, [_vm._v("#")]),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$t("Shelf Status Capture Time")))
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "capture-table-scroll" }, [
                _c("table", { staticClass: "capture-table" }, [
                  _c(
                    "tbody",
                    [
                      !_vm.shelfCaptureTimes.length
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "text-center",
                                attrs: { colspan: "2" }
                              },
                              [_vm._v(_vm._s(_vm.$t("No data available")))]
                            )
                          ])
                        : _vm._e(),
                      _vm._l(_vm.shelfCaptureTimes, function(item, index) {
                        return _c("tr", { key: index }, [
                          _c("td", { staticClass: "index-col" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _c("td", [_vm._v(_vm._s(item))])
                        ])
                      })
                    ],
                    2
                  )
                ])
              ])
            ]),
            _c(
              "div",
              { staticClass: "capture-modal-footer" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn",
                    attrs: { text: "" },
                    on: {
                      click: function($event) {
                        _vm.captureScheduleDialog = false
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Close")) + " ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }